/**
 * Title Component
 *
 * Título do artifact com ícone de documento
 */

import React, { memo } from 'react';

// =============================================================================
// TYPES
// =============================================================================

interface TitleProps {
  title: string;
}

// =============================================================================
// ICONS
// =============================================================================

const DocumentIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6z"
      fill="currentColor"
      opacity="0.3"
    />
    <path d="M14 2l6 6h-6V2z" fill="currentColor" />
  </svg>
);

// =============================================================================
// COMPONENT
// =============================================================================

export const Title: React.FC<TitleProps> = memo(({ title }) => {
  return (
    <div className="flex items-center gap-2 text-white">
      <DocumentIcon />
      <span className="font-medium truncate max-w-[200px]" title={title}>
        {title}
      </span>
    </div>
  );
});

Title.displayName = 'Title';

export default Title;
